/**
 * Turns an array of elements into groups
 * of a specific size
 */
export function chunk<T>(array: T[], size: number): Array<T[]> {
  const chunks: Array<T[]> = []
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size))
  }
  return chunks
}
